import { Reveal } from "./Reveal";

const quotes = [
    {
        text: "When my father was hospitalised, PolicyOne handled the entire cashless claim at Ganga Hospital. We didn't make a single phone call ourselves.",
        name: "Priya Ramesh",
        area: "Saibaba Colony · Health Insurance",
    },
    {
        text: "They compared six term plans for me and explained every exclusion in Tamil. I finally understood what I was paying for.",
        name: "Karthik Subramanian",
        area: "Peelamedu · Term Life",
    },
    {
        text: "Our textile unit's fire policy renewal used to take weeks of follow-up. PolicyOne sorted it in two days, at a better premium.",
        name: "Meera Krishnan",
        area: "R.S. Puram · Business Insurance",
    },
];

export const Testimonials = () => (
    <section data-testid="testimonials-section" className="border-y border-line bg-ink text-bone">
        <div className="mx-auto max-w-7xl px-6 py-32 md:px-12 md:py-40">
            <Reveal>
                <p className="mb-20 font-mono text-xs uppercase tracking-[0.25em] text-clay" data-testid="testimonials-overline">
                    Word around Coimbatore
                </p>
            </Reveal>
            <div className="grid grid-cols-1 gap-16 lg:grid-cols-3 lg:gap-10">
                {quotes.map((q, i) => (
                    <Reveal key={q.name} delay={i * 0.1}>
                        <figure data-testid={`testimonial-${i}`} className="flex h-full flex-col justify-between border-t border-bone/20 pt-8">
                            <blockquote className="font-serif text-2xl font-light leading-snug md:text-[1.7rem]">
                                “{q.text}”
                            </blockquote>
                            <figcaption className="mt-10">
                                <p className="font-mono text-sm uppercase tracking-[0.15em]">{q.name}</p>
                                <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.15em] text-bone/60">{q.area}</p>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
